import path from 'path';
import logger from '@/plugins/logger.js';
import ApiController from './apicontroller';

export default class BaseResourceController {
  constructor (resourcecontroller) {
    this.resourcecontroller = resourcecontroller;
    this.apicontroller = new ApiController();
    this.logger = logger;
  }
  /**
   * Needed to send requests to the server
   * @param  {Object} apicontroller Links the resource controller with the api.
   */
  linkApiController (apicontroller) {
    this.apicontroller = apicontroller;
  }

  getUri (relativeuri) {
    return path.join(this.resourcecontroller, relativeuri);
  }

  async Get (relativeuri, obj) {
    return this.apicontroller.Get(this.getUri(relativeuri), obj);
  }

  async Post (relativeuri, obj) {
    return this.apicontroller.Post(this.getUri(relativeuri), obj);
  }

  async Put (relativeuri, obj) {
    return this.apicontroller.Put(this.getUri(relativeuri), obj);
  }
}
